module.exports = new __parcel__URL__("github.12d0b60b.svg").toString();